import { UserRoleMap } from "../../models";
import { ClientMode } from "../../models/system";
import { get } from "../../utils/net";

import type {
  CurrentUserEntity,
  CurrentUserEntityRoles,
  CurrentUserServiceResponse,
  UserRole,
} from "../../models";

const baseURL = `${process.env.REACT_APP_API_PATH}/api/currentUser`;

const getCurrentUser = (options: { includeRoles?: boolean }): Promise<CurrentUserEntity> => {
  const url = `${baseURL}/Info?includeRoles=${options?.includeRoles || false}`;

  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result) => mapCurrentUser(result.body));
};

const mapCurrentUser = (payload: CurrentUserServiceResponse): CurrentUserEntity => {
  let clientMode = ClientMode.Standard;
  if (payload.ClientMode !== null && ClientMode[payload.ClientMode] !== undefined) {
    clientMode = ClientMode[payload.ClientMode];
  }
  const mapRole = (role: string): UserRole => UserRoleMap[role] ?? UserRoleMap.NoRole;

  const mapped: CurrentUserEntity = {
    isItAdmin: payload.IsItAdmin || false,
    isSystemAdmin: payload.IsSystemAdmin,
    highestRole: mapRole(payload.HighestRole),
    clientMode,
    allAvailablePermissions: payload.AllAvailablePermissions || "",
    commonPermissionsInAllFacilities: payload.CommonPermissionsInAllFacilities || "",
  };
  if (payload.Roles) {
    mapped.roles = payload.Roles.map((r) => {
      const role: CurrentUserEntityRoles = { facilityId: r.FacilityId, role: mapRole(r.Role) };
      return role;
    });
  }
  return mapped;
};

export const currentUserAPI = {
  getCurrentUser,
};
